<template>
  <div class="ide-layout">
    <ul>
      <li :class="{ active: currentTab === 'attribute' }" @click="currentTab = 'attribute'">属性</li>
      <li :class="{ active: currentTab === 'code' }" @click="currentTab = 'code'">代码</li>
    </ul>
    <div v-show="currentTab === 'attribute'" class="attributes">
      <slot name="global-attribute"></slot>
    </div>
    <div v-show="currentTab === 'code'" ref="splitPane" class="split-pane" :class="direction" :style="{ flexDirection: direction }">
      <div class="pane pane-menu" :style="lengthType + ':' + paneLengthValue">
        <slot name="menu"></slot>
      </div>
      <div
        class="pane-trigger"
        :style="lengthType + ':' + triggerBarWidthValue"
        @mousedown="handleMouseDown"
      ></div>
      <div class="pane pane-codespace">
        <slot name="codespace"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'row'
    },
    // 拖动最小宽度
    min: {
      type: Number,
      default: 200
    },
    // 拖动最大宽度
    max: {
      type: Number,
      default: 1000
    },
    // 默认宽度
    dragWidth: {
      type: Number,
      default: 200
    },
    // 拖动条宽度
    triggerBarWidth: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      currentTab: 'code',
      triggerLeftOffset: 0 // 鼠标距滑动器左(顶)侧偏移量
    }
  },
  computed: {
    lengthType () {
      return this.direction === 'row' ? 'width' : 'height'
    },

    paneLengthValue () {
      return `calc(${this.dragWidth}px - ${this.triggerBarWidth / 2 + 'px'})`
    },

    triggerBarWidthValue () {
      return this.triggerBarWidth + 'px'
    }
  },

  methods: {
    // 按下滑动器
    handleMouseDown (e) {
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)

      if (this.direction === 'row') {
        this.triggerLeftOffset = e.pageX - e.srcElement.getBoundingClientRect().left
      } else {
        this.triggerLeftOffset = e.pageY - e.srcElement.getBoundingClientRect().top
      }
    },

    // 按下滑动器后移动鼠标
    handleMouseMove (e) {
      const clientRect = this.$refs.splitPane.getBoundingClientRect()
      let dragWidth = 0

      if (this.direction === 'row') {
        const offset = e.pageX - clientRect.left - this.triggerLeftOffset + this.triggerBarWidth / 2
        dragWidth = offset
      } else {
        const offset = e.pageY - clientRect.top - this.triggerLeftOffset + this.triggerBarWidth / 2
        dragWidth = offset
      }

      if (dragWidth < this.min) {
        dragWidth = this.min
      }
      if (dragWidth > this.max) {
        dragWidth = this.max
      }

      this.$emit('update:dragWidth', dragWidth)
    },

    // 松开滑动器
    handleMouseUp () {
      document.removeEventListener('mousemove', this.handleMouseMove)
    }
  }
}
</script>

<style scoped lang="scss">
@import "./variables";
.ide-layout {
  height: 100%;
  display: flex;
  overflow: hidden;
  & > ul {
    flex-shrink: 0;
    background-color: $code-space-background;
    color: $color-white;
    font-size: 12px;
    li {
      writing-mode: tb;
      padding: 10px 3px;
      letter-spacing: 1px;
      cursor: pointer;
      &.active {
        background-color: $primary-color;
        font-weight: bold;
      }
    }
  }
  .attributes {
    width: 100%;
    height: 100%;
  }
  .split-pane {
    flex-grow: 1;
    height: 100%;
    display: flex;
    &.row {
      .pane {
        height: 100%;
        overflow-y: auto;
      }
      .pane-trigger {
        height: 100%;
        cursor: col-resize;
      }
    }
    &.column {
      .pane {
        width: 100%;
      }
      .pane-trigger {
        width: 100%;
        cursor: row-resize;
      }
    }
    .pane-menu {
      flex-shrink: 0;
    }
    .pane-trigger {
      user-select: none;
      background: $menu-background;
    }
    .pane-codespace {
      flex: 1;
    }
  }
}
</style>
